<template>
  <section id="download" class="bg-regular">
    <div class="section-inner text-center">
      <h2 class="text-center download">Download Tunnelbear to start browsing privately today!</h2>
      <router-link class="btn btn-lg" :to="{name: 'checkout'}">Get TunnelBear</router-link>
      <div class="footer-bear">
        <slot name="image"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'download-cta',
  data () {
    return {}
  }
}
</script>

<style scoped lang="stylus" src="./download-cta.styl" >
